var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBasket(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0643 9.67492C11.3136 10.3814 11.7759 10.9932 12.3874 11.4259C12.999 11.8586 13.7297 12.091 14.4789 12.091C15.2281 12.091 15.9588 11.8586 16.5704 11.4259C17.1819 10.9932 17.6442 10.3814 17.8935 9.67492M4.51502 22.4103C5.96291 24.1538 8.65598 24.1538 14.0445 24.1538H14.9133C20.3018 24.1538 22.9961 24.1538 24.444 22.4103C25.8919 20.6656 25.3948 18.0184 24.4018 12.7215C23.6959 8.95701 23.3424 7.07355 22.0019 5.96109C20.6626 4.84863 18.7453 4.84863 14.9145 4.84863H14.0433C10.2125 4.84863 8.29642 4.84863 6.95592 5.96109C5.61542 7.07355 5.2631 8.95701 4.55725 12.7215C3.56424 18.0184 3.06714 20.6656 4.51502 22.4103Z",
    stroke: "currentColor",
    strokeWidth: 1.99084,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasket);
export default __webpack_public_path__ + "static/media/basket.5c420bd417e907aa5698216899c1a541.svg";
export { ForwardRef as ReactComponent };